import React from "react";

import Paragraph from "../../Paragraph/Paragraph";
import NecessarySupport from "../NecessarySupport/NecessarySupport";
import styles from "./Accommodate.module.scss";

export default function Accommodate() {
  return (
    <div>
      <div className={styles['container']}>
        <Paragraph
          title="Các nhà giao dịch sẽ được hỗ trợ ra sao tại PipFarm?"
          content={[
            'Tại PipFarm, mỗi nhà giao dịch đều được trân trọng. Ưu tiên của chúng tôi là cung cấp cho các nhà giao dịch sự hỗ trợ cần thiết để họ có thể phát huy tối đa hiệu suất. Cuối cùng, chúng tôi là nhà cung cấp dịch vụ và cần cung cấp dịch vụ xuất sắc nếu muốn các nhà giao dịch tiếp tục hợp tác với chúng tôi. Mô hình kinh doanh của chúng tôi cần các nhà giao dịch cung cấp chiến lược của họ.',
            'Chúng tôi có dịch vụ hỗ trợ khách hàng trực tuyến bằng tiếng Việt để hỗ trợ nhà giao dịch theo thời gian thực và cung cấp các hướng dẫn chi tiết cho người dùng. Bạn sẽ cảm thấy như đang giao dịch với một công ty Việt Nam, chứ không phải một công ty nước ngoài.',
          ]}
          contentStyle={{ maxWidth: '1081px' }}
        />
      </div>
      <NecessarySupport />
    </div>
  );
}
